var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";

var SvgLegendParkingLot = function SvgLegendParkingLot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 20",
    ref: svgRef
  }, _extends({
    width: "1em",
    height: "1em"
  }, props)), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "LegendParkingLot_svg__a",
    d: "M1126.778 351H1119v20h4.445v-6.667h3.333a6.672 6.672 0 0 0 6.667-6.666 6.672 6.672 0 0 0-6.667-6.667m.222 8.899h-3.555v-4.454H1127a2.231 2.231 0 0 1 2.222 2.227c0 1.225-1 2.227-2.222 2.227"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#LegendParkingLot_svg__a",
    transform: "translate(-1119 -351)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegendParkingLot, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;